import React from "react";

/**
 * Renders an input field of type "time" with default value of 7:00 am.
 *
 * @param {Object} props - The properties object.
 * @param {boolean} props.disabled - Determines if the input field is disabled.
 *
 * @component
 * @example
 * return (
 *   <TimePicker />
 * )
 */
const TimePicker = ({ disabled = false }) => {
  return (
    <div>
      <input
        type="time"
        defaultValue="07:00"
        className="ml-2 p-[2px] rounded-3xl text-xs bg-emerald-800"
        disabled={disabled}
      />
    </div>
  );
};

export default TimePicker;
